export default __webpack_public_path__ + "e76d351.png";